export const downloadFile = (blob: Blob, fileName: string) => {
  let url = window.URL.createObjectURL(blob);
  let link = document.createElement('a');
  link.download = fileName;
  link.href = url;
  link.click();
  window.URL.revokeObjectURL(url);
};
